import { getString } from './utils';

const ejMap = {
  contract: '契約',
  device: '装置',
  account: 'アカウント',
};

const actStrEn = {
  NEW_CONFIRM: 'Create new $1?',
  UPDATE_CONFIRM: 'Update $1?',
  DELETE_CONFIRM: 'Delete $1?',
  UNASSIGN_CONFIRM: 'Unassign $1?',
  NEW_SUCCESS: '$1 created.',
  UPDATE_SUCCESS: '$1 updated.',
  DELETE_SUCCESS: '$1 deleted.',
  UNASSIGN_SUCCESS: '$1 unassigned.',
};

const stringEn = {
  BLANK: '',
  TITLE: 'AirInCom. Lite Console',
  TITLE_JP: 'Air-InCom. Lite (エアーインカム ライト) マイページ ログイン',
  MY_ACCOUNT: 'My Account',
  ACCOUNT_MANAGEMENT: 'Account Management',
  ACCOUNT_MAINTENANCE: 'Account Maintenance',
  LOG_IN: 'Log in',
  LOG_OUT: 'Log out',
  LOGIN_ID: 'Login ID',
  ACCOUNT_NAME: 'Account Name',
  ACCOUNT_ROLE: 'Role',
  ACCOUNT_MAIL: 'Mail Address',
  ACCOUNT_STATUS: 'Status',
  ACCOUNT_SELECT: 'Account Select',
  NEW_ACCOUNT: 'New Account',
  EMAIL_ADDRESS: 'Email Address',
  CHANGE_PASSWORD: 'Change Password',
  CURRENT_PASSWORD: 'Current Password',
  NEW_PASSWORD: 'New Password',
  CONFIRM_PASSWORD: 'Confirm New Password',
  PASSWORD: 'Password',
  UPDATE: 'Update',
  ACCOUNT_ROLE_ADMIN: 'System Manager',
  ACCOUNT_ROLE_PARENT: 'Service Manager',
  ACCOUNT_ROLE_CHILD: 'Normal',
  ALERT_REPORT: 'Alert Report',
  ACCOUNT_DELETED_ALERT: 'Account deleted',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  RECEIVE: 'Receive',
  NO_RECEIVE: "Don't Receive",
  SAVE: 'Save',
  CONTRACT_MANAGEMENT: 'Contract Management',
  NEW_CONTRACT: 'New Contract',
  ADD_CONTRACT: 'Add Contract',
  CONTRACT_NUMBER: 'Contract Number',
  CONTRACT_INFO: 'Contract Info',
  CONTRACT_EXPIRATION_DATE: 'Expiration Date',
  CONTRACT_ACTIVATION_DATE: 'Validation Date',
  DEVICE_LAST_TRACKED_TIME: 'Last Tracked Time',
  DEVICE_TRACKING_COUNT: 'Tracking Count',
  DEVICE_ACTIVITY: 'Device Activity',
  DEVICE_MANAGEMENT: 'Device Management',
  DEVICE_MAINTENANCE: 'Device Maintenance',
  DEVICE_NAME: 'Name',
  DEVICE_MODEL: 'Model',
  DEVICE_SERIALNO: 'Serial Number',
  DEVICE_STATUS: 'Device Status',
  DEVICE_SIGNAL_STRENGTH: 'Signal Strength',
  DEVICE_ID: 'Device ID',
  DEVICE_SIGFOX_ID: 'Sigfox ID',
  DEVICE_SELECT: 'Device Select',
  DEVICE_TEMPERATURE: 'Temperature',
  DEVICE_BATTERY: 'Battery',
  DEVICE_SENSOR: 'Sensor',
  DEVICE_DETAIL: 'Device Detail',
  DEVICE_DETAIL_STATUS: 'Status',
  DEVICE_DETAIL_JOURNEY: 'Journey',
  DEVICE_DETAIL_PAYLOAD: 'Payload',
  DEVICE_LOCATION: 'Location',
  DEVICE_LOCATION_UPDATE: 'Update Location',
  DEVICE_LOCATION_UPDATE_SUCCESS: 'Location Updated',
  LOCATION_LATITUDE: 'Latitude',
  LOCATION_LONGITUDE: 'Longitude',
  DEVICE_LOG_TIME: 'Log time',
  DEVICE_LOG_DATA: 'Data',
  DEVICE_LOG_SEQUENCENO: 'Sequence Number',
  DEVICE_INFO: 'Device Info',
  DEVICE_ACTIVE_ALERT: 'Active Alert',
  DEVICE_ALERT_DETAIL: 'Alert Detail',
  DEVICE_ALERT_DETECTION_TIME: 'Detection Time',
  DEVICE_ALERT_RESOLUTION_TIME: 'Resolution Time',
  DEVICE_ALERT_DETECTION_PERIOD: 'Detection Period',
  DEVICE_ALERT_HISTORY: 'Alert History',
  NEW_DEVICE: 'New Device',
  REQUIRE_RESET_PASSWORD: 'Require reset password on first login',
  ADD_DEVICE: 'Add Device',
  REMOVE_DEVICE: 'Remove Device',
  NOTI_STARTUP_REPORT: 'Startup report',
  NOTI_PERIODIC_REPORT: 'Periodic report',
  NOTI_EXTERNAL_INPUT_MONITOR: 'External input monitor',
  NOTI_TEMPERATURE_SENSOR: 'Temperature sensor',
  NOTI_FLOODING_SENSOR: 'Flooding sensor',
  NOTI_DROUGHT_SENSOR: 'Drought sensor',
  NOTI_SOUND_SENSOR: 'Sound sensor',
  NOTI_VIBRATION_SENSOR: 'Vibration sensor',
  NOTI_TILT_SENSOR: 'Tilt sensor',
  NOTI_ALERT_BUTTON: 'Alert button',
  NOTI_HEALTH_CHECK_CONFIRMED: 'Health check confirmed',
  NOTI_HEALTH_CHECK_UNCONFIRMED: 'Health check unconfirmed',
  NOTI_HEALTH_CHECK_START: 'Health check start',
  NOTI_DIP_SWITCH_CONFIRMATION: 'DIP switch confirmation',
  NOTI_STARTUP_COMPLETE: 'Startup complete',
  NOTI_TIME_DATA_REQUEST_STARTUP: 'Time data request on startup',
  NOTI_PERIODIC_TIME_DATA_REQUEST: 'Periodic time data request',
  NOTI_REQUEST_FOR_DOWNLINK_DATA: 'Request for downlink data',
  PAGINATION_TEXT: 'Showing $1 to $2, $3 items in total',
  PAGINATION_PERPAGE_1: 'Show',
  PAGINATION_PERPAGE_2: 'Items',
  AUTHENTICATION_LOG: 'Authentication log',
  PROCESSED_TIME: 'Processed Time',
  PROCESSED_RESULT: 'Processed Result',
  IP_ADDRESS: 'IP Address',
  CONFIRM: 'Confirm',
  ARE_YOU_SURE: 'Are you sure?',
  ROWS: '$1 Rows',
  DONE: 'DONE',
  FINISH: 'FINISH',
  OK: 'OK',
  ROW_SELECTED_COUNT: '$1 Row Selected',
  N_ITEM_SELECT: 'Select $1 Items',
  CSV_DOWNLOAD: 'CSV Download',
  CHANGE_PASSWORD_CONFIRM: 'Do you want to change the password?',
  CHANGE_PASSWORD_SUCCESS: 'Password Changed',
  PASSWORD_EMPTY_ERR: 'Password Empty.',
  NEW_PASSWORD_NOT_MATCHED_ERR: 'New Password Not Matched.',
  UNKNOWN_EXCEPTION: 'Unknown Exception',
  ACCOUNT_UNASSIGN_CONTRACT_CONFIRM: 'Unassign contract $1 from account $2?',
  LOCATION_UPDATE_CONFIRM: getString(actStrEn.UPDATE_CONFIRM, [ 'location' ]),
  LOCATION_UPDATE_SUCCESS: getString(actStrEn.UPDATE_SUCCESS, [ 'Location' ]),
  ...[ 'contract', 'account', 'device' ].reduce((prev, val) => {
    let valU = val.toUpperCase();
    let valN = val[ 0 ].toUpperCase() + val.substr(1);
    prev[ `${valU}_NEW_CONFIRM` ] = getString(actStrEn.NEW_CONFIRM, [ val ]);
    prev[ `${valU}_UPDATE_CONFIRM` ] = getString(actStrEn.UPDATE_CONFIRM, [ val ]);
    prev[ `${valU}_DELETE_CONFIRM` ] = getString(actStrEn.DELETE_CONFIRM, [ val ]);
    prev[ `${valU}_NEW_SUCCESS` ] = getString(actStrEn.NEW_SUCCESS, [ valN ]);
    prev[ `${valU}_UPDATE_SUCCESS` ] = getString(actStrEn.UPDATE_SUCCESS, [ valN ]);
    prev[ `${valU}_DELETE_SUCCESS` ] = getString(actStrEn.DELETE_SUCCESS, [ valN ]);
    return prev;
  }, {}),
  DEVICE_SF07NAME: 'DK-SF07',
  DEVICE_SF07: 'DK-SF07',
  DEVICE_SFGPS: 'DK-SFGPS',
  DEVICE_SF04: 'DK-SF04',
  DEVICE_SF03: 'DK-SF03',
  DEVICE_WBGT: 'WBGT',
  DEVICE_SF03WT: 'DK-SF03WT',
  DEVICE_SF03WT2: 'DK-SF03WT2',
  DEVICE_XE1151: 'XE1151',
  MAIL_TEMPLATE_TITLE: 'TITLE',
  MAIL_TEMPLATE_HEADER: 'HEADER',
  MAIL_TEMPLATE_CONTENT: 'CONTENT',
  MAIL_TEMPLATE_FOOTER: 'FOOTER',
};

const actStrJP = {
  NEW_CONFIRM: '$1を新規登録してもよろしいですか？',
  UPDATE_CONFIRM: '$1の情報を更新してもよろしいですか？',
  DELETE_CONFIRM: '$1を消去してもよろしいですか？',
  UNASSIGN_CONFIRM: '$1を解除してもよろしいですか？',
  NEW_SUCCESS: '$1を新規登録しました。',
  UPDATE_SUCCESS: '$1の情報を更新しました。',
  DELETE_SUCCESS: '$1を消去しました。',
  UNASSIGN_SUCCESS: '$1を解除しました。',
};

// console.log(Object.keys(stringEn).filter((e) => !stringJp[e]));

const string = {
  ...stringEn,
  ...{
    DEVICE_STATUS: '状態表示',
    DEVICE_STATUS_DETAIL: '装置状態',
    DEVICE_MANAGEMENT: '装置設定',
    CONTRACT_MANAGEMENT: '契約情報管理',
    CONTRACT_NUMBER: '契約番号',
    CONTRACT_CODE: '契約コード',
    ACCOUNT_MANAGEMENT: 'ユーザー管理',
    ACCOUNT_MAINTENANCE: 'ユーザー登録',
    ACCOUNT_CUSTOMER_ID: '顧客番号',
    ACCOUNT_CUSTOMER_ID_EMPTY_ERROR: '顧客番号は未入力です。',
    ACCOUNT_MAIL: 'メールアドレス',
    ACCOUNT_ROLE: 'ロール',
    ACCOUNT_STATUS: 'ステータス',
    ACCOUNT_SELECT: 'アカウント選択',
    ALERT_REPORT: 'アラートレポート',
    RECEIVE: '受信する',
    NO_RECEIVE: '受信しない',
    ACTIVE: '有効',
    INACTIVE: '無効',
    ACCOUNT_ROLE_ADMIN: 'システム管理者',
    ACCOUNT_ROLE_PARENT: 'サービス管理者',
    ACCOUNT_ROLE_CHILD: '普通',
    ACCOUNT_ROLE_NORMAL: '普通',
    ACCOUNT_ROLE_MONITOR: 'サービス管理者',
    REQUIRE_RESET_PASSWORD: '初回ログイン時にパスワードを変更する',
    PAGINATION_TEXT: '$3件中$1から$2まで表示',
    PAGINATION_PERPAGE_1: '表示数',
    PAGINATION_PERPAGE_2: '',
    DEVICE_MAINTENANCE: '装置設定',
    DEVICE_NAME: '装置名称',
    DEVICE_MODEL: '装置種別',
    DEVICE_STATE: '状態',
    DEVICE_SERIALNO: 'シリアル番号',
    DEVICE_SENSOR: '状態表示',
    //DEVICE_SENSOR: '状態表示',
    //DEVICE_STATUS: '状態表示',
    DEVICE_BATTERY: '電源情報',
    DEVICE_TEMPERATURE: '温度',
    DEVICE_WBGT_DATA: 'WBGTデータ',
    DEVICE_WBGT_DATA_TITLE: 'WBGT暑さ指数',
    DEVICE_SIGNAL_STRENGTH: '通信品質',
    DEVICE_DETAIL: '装置詳細',
    DEVICE_DETAIL_STATUS: 'ステータス',
    DEVICE_DETAIL_JOURNEY: '移動履歴',
    DEVICE_DETAIL_PAYLOAD: 'ペイロード',
    DEVICE_DETAIL_THRESH: 'メール送信設定',
    GPS_MAIL_SETTING: 'メール送信設定',
    DEVICE_ACTIVITY: 'アクティビティ',
    DEVICE_LAST_TRACKED_TIME: '最終検知時間',
    DEVICE_TRACKING_COUNT: '検知件数',
    DEVICE_LOCATION: 'ロケーション',
    DEVICE_LOCATION_UPDATE: 'ロケーション更新',
    DEVICE_LOCATION_UPDATE_SUCCESS: '位置の情報を更新しました。',
    LOCATION_LATITUDE: '緯度',
    LOCATION_LONGITUDE: '経度',

    DEVICE_INFO: '装置情報',
    DEVICE_ID: '装置ID',
    DEVICE_LOG_TIME: '受信日時',
    DEVICE_LOG_DATA: 'データ',
    DEVICE_LOG_SEQUENCENO: 'シーケンス番号',
    DEVICE_ACTIVE_ALERT: 'アクティブアラート',
    DEVICE_ALERT_DETAIL: '詳細情報',
    DEVICE_ALERT_TITLE: '装置詳細',
    // DEVICE_ALERT_DETECTION_TIME: '検出日時',
    DEVICE_ALERT_DETECTION_TIME: '通知時間',
    DEVICE_ALERT_RESOLUTION_TIME: '解除日時',
    DEVICE_ALERT_DETECTION_PERIOD: '検出時間',
    DEVICE_ALERT_DETECTION_POSITION: '位置情報',
    DEVICE_ALERT_DETECTION_LAT: '緯度',
    DEVICE_ALERT_DETECTION_LONG: '軽度',
    DEVICE_ALERT_DETECTION_DEVICE_URL: 'WebアプリへのURL',
    DEVICE_ALERT_DETECTION_MAP_URL: 'グーグルマップへのURL',
    // DEVICE_ALERT_HISTORY: 'アラート履歴',
    DEVICE_ALERT_HISTORY: '通知履歴',
    ADD_DEVICE: '装置追加',
    REMOVE_DEVICE: '装置削除',
    DEVICE_SELECT: '装置選択',
    SERVICE_ACCOUNT_SELECT: 'サービス管理者アカウント選択',
    CONTRACT_SELECT: 'アカウント選択',
    ADD_CONTRACT: '契約割当',
    CONTRACT_INFO: '契約詳細',
    CONTRACT_EDIT: '契約情報編集',
    CONTRACT_ACTIVATION_DATE: '開始日',
    CONTRACT_EXPIRATION_DATE: '終了日',
    LOG_TIME: '履歴期間表示',
    PROCESSED_TIME: '処理時間',
    PROCESSED_RESULT: '処理結果',
    STARTED_TIME: '開始時間',
    LOGIN_ID: 'メールアドレス',
    LOG_IN: 'ログイン',
    LOG_IN_DETAILS: 'こちらのマイページは、マイページアカウントをお持ちの方がログイン可能となっております。アカウントをお持ちでない場合は、「新規マイページアカウント登録」メニューよりご登録いただけます。',
    NEXT_STEP: '次へ',
    LOG_OUT: 'ログアウト',

    ACCOUNT_NAME: 'アカウント名',
    ACCOUNT_NAME_KANJI: '名前',
    ACCOUNT_NAME_HIRA: 'フリガナ',
    EMAIL_ADDRESS: 'メールアドレス',
    PHONE_NUMBER: '電話番号',
    REGISTER_DATE: '登録日',
    ACTIVE_APP_ACCOUNT: '有効アプリアカウント数',
    ACTIVE_CHANNEL: '有効チャンネル数',
    REGISTER_APP_ACCOUNT: '登録進行中アプリアカウント数',
    REGISTER_CHANNEL: '登録進行中チャンネル数',
    APP_LOGIN_ID: 'ログインID',
    APP_ID: 'アプリID',
    APP_SECRET_CHANNEL: 'シークレットCH',

    CHANGE_PASSWORD: 'パスワード変更',
    CURRENT_PASSWORD: '現在のパスワード',
    NEW_PASSWORD: '新しいパスワード　　　',
    UPDATE: '更新',
    CONFIRM: '確認',
    CONFIRM_NEW_PASSWORD: '新しいパスワード再入力',
    CONFIRM_PASSWORD: 'パスワード再入力',
    MY_ACCOUNT: 'マイアカウント設定',
    PASSWORD: 'パスワード',
    PASSWORD_REPEAT: 'パスワード（再入力）',
    ACTIVATE_CODE: 'アクティベーションコード',
    IP_ADDRESS: 'IPアドレス',
    NOTI_FLOODING_SENSOR: '浸水検出',
    NOTI_HIGH_FLOOD_LEVEL: '浸水レベル高',
    NOTI_LOW_FLOOD_LEVEL: '浸水レベル低',
    NOTI_TILT_SENSOR: '傾斜異常',
    NOTI_DROUGHT_SENSOR: '正常',
    NOTI_NORMAL: '正常',
    SAVE: '保存',
    ADD: '追加',
    SELECT: '選択',
    SELECT_ALL: 'すべて選択',
    UN_SELECT_ALL: 'すべて解除',
    ARE_YOU_SURE: '進んでもよろしいですか？',
    NEW_ACCOUNT: 'アカウント登録',
    ROWS: '$1件',
    CSV_DOWNLOAD: 'CSVダウンロード',
    NEW_DEVICE: '装置登録',
    NEW_CONTRACT: '契約登録',
    ACCOUNT_DELETED_ALERT: 'アカウントが削除されました。',
    DONE: '完了',
    FINISH: '完了',
    ROW_SELECTED_COUNT: '選択件数：$1件',
    N_ITEM_SELECT: '$1件を選択する',
    ITEM_SELECT: '選択する',
    CHANGE_PASSWORD_CONFIRM: 'パスワードを変更してもよろしいですか？',
    CHANGE_PASSWORD_SUCCESS: 'パスワードを変更しました。',

    MAIL_ADDRESS_EMPTY_ERR: 'メールアドレスは未入力です。',
    MAIL_ADDRESS_FORMAT_ERR: '入力したメールアドレスは無効です。',
    MAIL_ADDRESS_EXIST_ERR: '入力したメールアドレスが既に登録されています。',

    PASSWORD_EMPTY_ERR: 'パスワードは未入力です。',
    CONFIRM_PASSWORD_EMPTY_ERR: '確認用パスワードは未入力です。',
    PASSWORD_CONFIRM_ERR: 'パスワードと確認用パスワードは一致しません。',

    USERNAME_EMPTY_ERR: 'お名前は未入力です。',
    FURIGANA_EMPTY_ERR: 'ふりがなは未入力です。',
    PHONENUMBER_EMPTY_ERR: '電話番号は未入力です。',
    PHONENUMBER_FORMAT_ERR: '入力した電話番号は無効です。',
    OTP_EMPTY_ERR: 'アクティブコードは未入力です。',
    POLICY_UNCHECK_ERR:
      'アプリケーションのプライバシー・ポリシーのチェックボックスをオンにしてください。',

    ACCOUNT_NAME_EMPTY_ERR: 'アカウント名は未入力です。',
    LOGIN_ID_EMPTY_ERR: 'ログインIDは未入力です。',
    ACTIVE_CODE_EMPTY_ERR: 'アクティベーションコードは未入力です。',
    CONTRACT_NUMBER_EMPTY_ERR: '契約番号は未入力です。',
    LOGIN_ID_VERY_LONG_ERR: 'ログインIDの長さは長すぎる',
    NEW_PASSWORD_NOT_MATCHED_ERR: '新しいパスワードが一致しません。',
    PASSWORD_NOT_MATCHED_ERR: 'パスワードが一致しません。',
    UNKNOWN_EXCEPTION: '予期せぬエラーが発生しています。',
    CONTRACT_ASSIGN_DEVICE_CONFIRM:
      '$1の契約に装置を追加してもよろしいですか？',
    CONTRACT_ASSIGN_DEVICE_SUCCESS: '装置を追加ました。',
    CONTRACT_ASSIGN_ACCOUNT_CONFIRM:
      '$1アカウントに$2の契約を追加してもよろしいですか？',
    CONTRACT_ASSIGN_ACCOUNT_SUCCESS: '契約を追加しました。',
    CONTRACT_UNASSIGN_DEVICE_CONFIRM: getString(actStrJP.UNASSIGN_CONFIRM, [
      '$1の契約から装置',
    ]),
    CONTRACT_UNASSIGN_DEVICE_SUCCESS: getString(actStrJP.UNASSIGN_SUCCESS, [
      '装置',
    ]),
    ACCOUNT_ASSIGN_DEVICE_CONFIRM:
      '$1のアカウントに装置を割り当ててもよろしいですか？',
    ACCOUNT_ASSIGN_DEVICE_SUCCESS: '装置を割り当てました。',
    ACCOUNT_UNASSIGN_CONTRACT_CONFIRM: getString(actStrJP.UNASSIGN_CONFIRM, [
      '$1のアカウントから$2の契約の割り当て',
    ]),
    ACCOUNT_UNASSIGN_CONTRACT_SUCCESS: getString(actStrJP.UNASSIGN_SUCCESS, [
      '契約',
    ]),
    ACCOUNT_UNASSIGN_DEVICE_CONFIRM: getString(actStrJP.UNASSIGN_CONFIRM, [
      '$1のアカウントから$2の装置の割り当て',
    ]),
    ACCOUNT_UNASSIGN_DEVICE_SUCCESS: getString(actStrJP.UNASSIGN_SUCCESS, [
      '装置',
    ]),
    ACCOUNT_DEVICE_ALREADY_ASSIGNED: '$1の装置が既に$2に割り当てされています。',
    LOCATION_UPDATE_CONFIRM: getString(actStrJP.UPDATE_CONFIRM, [
      'ロケーション',
    ]),
    LOCATION_UPDATE_SUCCESS: getString(actStrJP.UPDATE_SUCCESS, [
      'ロケーション',
    ]),
    AUTHENTICATION_LOG: '認証ログ',
    ...[ 'contract', 'account', 'device' ].reduce((prev, val) => {
      let valU = val.toUpperCase();
      let valJ = ejMap[ val ];
      prev[ `${valU}_NEW_CONFIRM` ] = getString(actStrJP.NEW_CONFIRM, [ valJ ]);
      prev[ `${valU}_UPDATE_CONFIRM` ] = getString(actStrJP.UPDATE_CONFIRM, [
        valJ,
      ]);
      prev[ `${valU}_DELETE_CONFIRM` ] = getString(actStrJP.DELETE_CONFIRM, [
        `$1の${valJ}`,
      ]);
      prev[ `${valU}_NEW_SUCCESS` ] = getString(actStrJP.NEW_SUCCESS, [ valJ ]);
      prev[ `${valU}_UPDATE_SUCCESS` ] = getString(actStrJP.UPDATE_SUCCESS, [
        valJ,
      ]);
      prev[ `${valU}_DELETE_SUCCESS` ] = getString(actStrJP.DELETE_SUCCESS, [
        valJ,
      ]);
      return prev;
    }, {}),
    DEVICE_NEW_CONFIRM: getString(actStrJP.NEW_CONFIRM, [ '装置' ]),
    DEVICE_UPDATE_CONFIRM: getString(actStrJP.UPDATE_CONFIRM, [ '装置名称' ]),
    DEVICE_UPDATE_SUCCESS: getString(actStrJP.UPDATE_SUCCESS, [ '装置名称' ]),
    GEO_NEW_CONFIRM: getString(actStrJP.NEW_CONFIRM, [ 'ジオフェンス' ]),
    GEO_UPDATE_CONFIRM: getString(actStrJP.UPDATE_CONFIRM, [ 'ジオフェンス' ]),
    GEO_UPDATE_SUCCESS: getString(actStrJP.UPDATE_SUCCESS, [ 'ジオフェンス' ]),
    TEMPERATURE: '気温',
    LIGHT_TEMPERATURE: '黒球温度',
    WBGT_TEMPERATURE: 'WBGT',
    HUMIDITY: '湿度',
    MAIL_TEMPLATE: 'メールテンプレート',
    TEMPLATE_1: '高い暑さ指数検出のメール',
    TEMPLATE_2: '安全な暑さ指数検出のメール',
    TEMPLATE_3: '暑さ指数定期測定の結果のメール',
    DISPLAY_HOVER: '表示',
    SETTING_VALUE_ERROR: `無効な設定値になっています。\n※設定値について次の条件をご確認してください。\n① Lev.1-4で設定値が重複しないこと。\n② Lev.4（WBGT高）→ Lev.1（WBGT低）とする。\n③ 下限値が上限値より低い設定値であること。`,
    STATE_DANGER: '危険',
    STATE_CAUTION: '厳重警戒 ',
    STATE_VIGILANCE: '警戒 ',
    STATE_WARNING: '注意',
    STATE_NORMAL: 'ほぼ安全 ',
    MANAGING_DEVICES: '',
    TIME_GRAPH: 'グラフ表示期間指定',
    TIME_PAYLOAD: 'ペイロード表示期間指定',
    RANGE_MEASURE: '縦軸の範囲設定',
    GRAPH_TEXT: '$1から$2までのデータがありません',
    ADD_CONTRACT_ERROR: '$1の契約が不正解',
    STATUS_CODE_200: 'ログイン成功',
    STATUS_CODE_401: 'ログインID又はパスワードが一致しません',
    MAIL_LENGTH_ERROR: '',
    MAIL_FORM: '発信者：',
    MAIL_FORM_USER: 'no-reply@airincomlite.com',
    MAIL_TO: '宛先：',
    MAIL_DATE: '日付：',

    LOGIN: 'マイページ ログイン画面へ',
    SIGNUP: '新規 マイページ アカウント登録',
    SIGNUP_TITLE: '新規 マイページ アカウント登録',
    SIGNUP_FIRST_STEP: '情報入力',
    SIGNUP_SECOND_STEP: 'OTP確認',
    SIGNUP_THIRD_STEP: '登録結果',

    SIGNUP_MAIL_TITLE: 'メールアドレス(ログインID)',
    SIGNUP_MAIL_SAMPLE: '例：user@airincomlite.com',

    SIGNUP_PASSWORD_TITLE: 'パスワード',
    SIGNUP_PASSWORD_SAMPLE: 'マイページログイン用のパスワード',

    SIGNUP_CONFIRM_TITLE: 'パスワード再入力',
    SIGNUP_CONFIRM_SAMPLE:
      'ご確認のため、入力したパスワードを再入力してください。',

    SIGNUP_NAME_TITLE: 'お名前',
    SIGNUP_NAME_SAMPLE: '例：山本 一郎',

    SIGNUP_FURIGANA_TITLE: 'フリガナ',
    SIGNUP_FURIGANA_SAMPLE: '例：ヤマモト イチロウ',

    SIGNUP_PHONE_TITLE: '電話番号',
    SIGNUP_PHONE_SAMPLE: '例：0655553333',

    POLICY_PRIVACY: 'プライバシーポリシー',
    TERMS_OF_USE: '利用規約',
    SIGNUP_PRIVACY_CONFIRM: 'プライバシーポリシー',
    SIGNUP_PRIVACY_CONFIRM_OK: '○確認済',
    SIGNUP_TERMS_OF_USE_CONFIRM: '利用規約',
    SIGNUP_TERMS_OF_USE_CONFIRM_OK: '○確認済',
    SIGNUP_CONFIRM: 'プライバシーポリシーと利用規約を読み、同意してください。',
    SIGNUP_CONFIRM_CHECK: '同意する',
    SIGNUP_SUBMIT: 'アカウント登録',

    SIGNUP_OTP_TITLE: '認証コード入力',
    SIGNUP_OPT_SAMPLE: 'メール記載の認証コードを入力してください。',
    SIGNUP_OPT_CONFIRM: '認証コード送信',
    SIGNUP_OPT_ERR: '認証コードが一致しません。',
    SIGNUP_FINISH_MESSAGE: 'マイページのアカウント登録が完了しました。',
    SIGNUP_FINISH: 'マイページに入る',

    FORGET_PASSWORD: 'パスワードをお忘れの方',
    FORGET_PASSWORD_STEP_LOGINID: '',
    FORGET_PASSWORD_STEP_EMAIL:
      '登録時に設定したメールアドレスを入力してください',
    FORGET_PASSWORD_STEP_ACTIVE_CODE:
      'メールに送信したアクティブなコードを入力してください',
    FORGET_PASSWORD_STEP_NEW_PASSWORD: '新しいパスワードを入力してください',

    PASSWORD_RECOVERY_TITLE: 'パスワード再設定',
    PASSWORD_RECOVERY_MAIL_TITLE:
      '登録したメールアドレス(ログインID)を入力してください。',
    PASSWORD_RECOVERY_MAIL_SAMPLE: '例：user@airincomlite.com',

    PASSWORD_RECOVERY_OTP_TITLE: '認証コード入力',
    PASSWORD_RECOVERY_OPT_SAMPLE:
      'メール記載の認証コードを入力してください。',
    PASSWORD_RECOVERY_OPT_CONFIRM: '次へ',
    PASSWORD_RECOVERY_OPT_ERR: '認証コードが一致しません。',

    PASSWORD_RECOVERY: '次へ',
    PASSWORD_RECOVERY_EMAIL_NOT_EXIST_ERR:
      '入力したメールアドレスが未登録です。',

    PASSWORD_RECOVERY_NEW_PASSWORD_TITLE: '新しいパスワードを入力してください',
    PASSWORD_RECOVERY_NEW_PASSWORD_SAMPLE: '',
    PASSWORD_RECOVERY_NEW_PASSWORD_CONFIRM_TITLE:
      '新しいパスワードを再入力してください',
    PASSWORD_RECOVERY_NEW_PASSWORD_CONFIRM_SAMPLE: '',

    LOGINID_NOT_EXIST: 'ログインIDが存在しません',
    ACCOUNT_CREATE_CONFIRM: '新しいアカウントを作成してもよろしいですか？',
    ACCOUNT_CREATE_SUCCESS: '新しいアカウント作成が完了しました。',
    ACCOUNT_CREATE: '作成',
    ACCOUNT_CREATE_TITLE: '新しいアカウント作成',
    ACCOUNT_UPDATE_CONFIRM: 'アカウント設定を更新してもよろしいですか？',
    ACCOUNT_UPDATE_SUCCESS: 'アカウント設定更新が完了しました。',
    ACCOUNT_UPDATE: '更新',
    ACCOUNT_UPDATE_TITLE: 'アカウント設定更新',
    ACCOUNT_DELETE_CONFIRM: 'アカウントを無効化にしてもよろしいですか？',
    ACCOUNT_DELETE_SUCCESS: 'アカウント無効化が完了しました。',
    ACCOUNT_APPROVE_CONFIRM: 'アカウントを有効化にしてもよろしいですか？',
    ACCOUNT_APPROVE_SUCCESS: 'アカウント有効化が完了しました。',

    ACCOUNT_CUSTOMER_ID_UPDATE_CONFIRM: '顧客番号を更新してもよろしいですか？',
    ACCOUNT_CUSTOMER_ID_UPDATE_SUCCESS: '顧客番号更新が完了しました。',
    ACCOUNT_CUSTOMER_ID_UPDATE: '更新',
    ACCOUNT_CUSTOMER_ID_UPDATE_TITLE: '顧客番号更新',

    POC_CHANNEL_LIST: 'シークレットCH一覧',
    POC_CHANNEL_MANAGEMENT: 'シークレットCH管理',
    POC_CHANNEL_MAINTENANCE: 'シークレットCH変更',
    POC_CHANNEL_CREATE: '登録',
    POC_CHANNEL_CREATE_TITLE: 'シークレットCH登録',
    POC_CHANNEL_CREATE_CONFIRM: 'シークレットCHを登録してもよろしいですか？',
    POC_CHANNEL_CREATE_SUCCESS: 'シークレットCH登録が完了しました。',
    POC_CHANNEL_APPROVE_CONFIRM: 'シークレットCHを有効化にしてもよろしいですか？',
    POC_CHANNEL_APPROVE_SUCCESS: 'シークレットCH有効化が完了しました。',
    POC_CHANNEL_UPDATE_CONFIRM: 'シークレットCHを変更してもよろしいですか？',
    POC_CHANNEL_UPDATE_SUCCESS: 'シークレットCH変更が完了しました。',
    POC_CHANNEL_DELETE_CONFIRM: 'シークレットCHを無効化にしてもよろしいですか？',
    POC_CHANNEL_DELETE_SUCCESS: 'シークレットCH無効化が完了しました。',
    POC_CHANNEL_SAVE: '保存',

    POC_CHANNEL_NAME: 'チャンネル名',
    POC_CHANNEL_ID: '識別番号',
    POC_CHANNEL_TYPE: '種別',
    POC_CHANNEL_OWNER: '管理者',
    POC_CHANNEL_MEMBER: '参加者',
    POC_CHANNEL_HOST: 'ホスト',
    POC_CHANNEL_MEMBER_LIST: '参加者一覧',
    POC_CHANNEL_MEMBER_ADD: '参加者追加',
    POC_CHANNEL_MEMBER_ADD_CONFIRM: '参加者を追加してもよろしいですか？',
    POC_CHANNEL_MEMBER_ADD_SUCCESS: '参加者追加が完了しました。',
    POC_CHANNEL_MEMBER_REMOVE: '複数退出',
    POC_CHANNEL_REMOVE: '退出',
    POC_CHANNEL_MEMBER_REMOVE_CONFIRM: '参加者を消去してもよろしいですか？',
    POC_CHANNEL_MEMBER_REMOVE_SUCCESS: '参加者消去が完了しました。',
    POC_CHANNEL_SIP: 'SIP番号',
    POC_CHANNEL_STATUS: 'ステータス',
    POC_CHANNEL_PLAN_TYPE: '種別',
    POC_CHANNEL_PLAN_TYPE_DISABLE: '無効',
    POC_CHANNEL_PLAN_TYPE_MONTHLY_PAID: '定額制',
    POC_CHANNEL_PLAN_TYPE_PREPAID: 'プリペイド',
    POC_CHANNEL_REMAINING_TIME: '残り時間',
    POC_CHANNEL_VALID_UNTIL: '有効期限',
    POC_CHANNEL_ASSIGN: '処理中',
    POC_CHANNEL_REGISTERED_DATE: '登録日',
    POC_CHANNEL_UPDATE_STATUS_DATE: '有効化日',
    POC_CHANNEL_UPDATE: 'シークレットCH変更',
    POC_CHANNEL_SETTING: 'シークレットCH設定',
    POC_CHANNEL_HOST_LIST: 'ホスト設定',
    POC_CHANNEL_HOST_ADD: 'ホスト設定',
    POC_CHANNEL_HOST_ADD_CONFIRM: 'ホストを設定してもよろしいですか？',
    POC_CHANNEL_HOST_ADD_SUCCESS: 'ホスト設定が完了しました。',
    POC_CHANNEL_HOST_REMOVE: '複数退出',
    POC_CHANNEL_HOST_REMOVE_CONFIRM: 'ホストを消去してもよろしいですか？',
    POC_CHANNEL_HOST_REMOVE_SUCCESS: 'ホスト消去が完了しました。',

    POC_CHANNEL_REGISTER_TITLE: '有償',
    POC_CHANNEL_REGISTER: '申込',
    POC_CHANNEL_UNREGISTER: '解約',

    POC_ACCOUNT_REGISTER_TITLE: '有償ID',
    POC_ACCOUNT_REGISTER: '申込',
    POC_ACCOUNT_UNREGISTER: '解約',

    POC_ACCOUNT_COUPON_TITLE: 'クーポンコード',
    POC_ACCOUNT_COUPON: '入力',
    POC_ACCOUNT_COUPON_MODEL: '機種',
    POC_ACCOUNT_COUPON_SERIAL: 'シリアル番号',
    POC_ACCOUNT_COUPON_SERIAL_EMPTY_ERROR: 'シリアル番号は未入力です。',
    POC_ACCOUNT_COUPON_SERIAL_FORMAT_ERROR: 'シリアル番号は無効です。',
    POC_ACCOUNT_COUPON_CODE: 'クーポンコード',
    POC_ACCOUNT_COUPON_CODE_APPLY_CONFIRM: 'クーポンコードを適用してもよろしいですか？',
    POC_ACCOUNT_COUPON_CODE_APPLY_SUCCESS: 'クーポンコード適用が完了しました。',
    POC_ACCOUNT_COUPON_CODE_APPLY_FAILED: 'クーポンコード適用にエラーが発生しました。',
    POC_ACCOUNT_COUPON_CODE_APPLY_ERROR: '無効なクーポンコードです。',
    POC_ACCOUNT_COUPON_CODE_REPEAT_ERROR: '５回連続無効なクーポンコードが入力されたため、暫くの間クーポンコードを入力いただけません。',
    POC_ACCOUNT_COUPON_CODE_EMPTY_ERROR: 'クーポンコードは未入力です。',
    POC_ACCOUNT_COUPON_CODE_FORMAT_ERROR: 'クーポンコードは無効です。',
    POC_ACCOUNT_COUPON_SUBMIT: '適用',
    POC_ACCOUNT_COUPON_REAPPLY: '再度クーポンコードをご入力お願いします。',

    POC_ACCOUNT_COUPON_CODE1: 'クーポン４桁コード１',
    POC_ACCOUNT_COUPON_CODE1_EMPTY_ERROR: 'クーポン４桁コード１は未入力です。',
    POC_ACCOUNT_COUPON_CODE2: 'クーポン４桁コード２',
    POC_ACCOUNT_COUPON_CODE2_EMPTY_ERROR: 'クーポン４桁コード２は未入力です。',
    POC_ACCOUNT_COUPON_CODE3: 'クーポン４桁コード３',
    POC_ACCOUNT_COUPON_CODE3_EMPTY_ERROR: 'クーポン４桁コード３は未入力です。',
    POC_ACCOUNT_COUPON_CODE4: 'クーポン４桁コード４',
    POC_ACCOUNT_COUPON_CODE4_EMPTY_ERROR: 'クーポン４桁コード４は未入力です。',

    POC_ACCOUNT_LIST: 'アプリID一覧',
    POC_ACCOUNT_MANAGEMENT: 'アプリID管理',
    POC_ACCOUNT_MAINTENANCE: 'アプリID変更',
    POC_ACCOUNT_CREATE: '登録',
    POC_ACCOUNT_CREATE_TITLE: 'アプリID登録',
    POC_ACCOUNT_TRIAL: 'アプリID試用設定',
    POC_ACCOUNT_TRIAL_TITLE: 'アプリID試用',
    POC_ACCOUNT_TRIAL_ACTIVE: '有効化設定',
    POC_ACCOUNT_TRIAL_SUCCESS: 'アプリID試用有効化設定が完了しました。',
    POC_ACCOUNT_TRIAL_ADD_CONFIRM: 'アプリID試用を有効化してもよろしいですか？',
    POC_ACCOUNT_TRIAL_REMAINING_TIME: '試用時間（時）',
    POC_ACCOUNT_TRIAL_REMAINING_TIME_EMPTY_ERROR: '試用時間は未入力です。',
    POC_ACCOUNT_CREATE_CONFIRM: 'アプリIDを登録してもよろしいですか？',
    POC_ACCOUNT_CREATE_SUCCESS: 'アプリID登録が完了しました。',
    POC_ACCOUNT_APPROVE_CONFIRM: 'アプリIDを有効化にしてもよろしいですか？',
    POC_ACCOUNT_APPROVE_SUCCESS: 'アプリID有効化が完了しました。',
    POC_ACCOUNT_UPDATE_CONFIRM: 'アプリIDを変更してもよろしいですか？',
    POC_ACCOUNT_UPDATE_SUCCESS: 'アプリID変更が完了しました。',
    POC_ACCOUNT_PASSWORD_CONFIRM: 'アプリIDのパスワードを変更してもよろしいですか？',
    POC_ACCOUNT_PASSWORD_SUCCESS: 'アプリIDのパスワード変更が完了しました。',
    POC_ACCOUNT_BAN_CONFIRM: 'アプリIDを無効化にしてもよろしいですか？',
    POC_ACCOUNT_BAN_SUCCESS: 'アプリID無効化が完了しました。',
    POC_ACCOUNT_DELETE_CONFIRM: getString('ログインID【$1】を削除してもよろしいですか？'),
    POC_ACCOUNT_DELETE_SUCCESS: getString('ログインID【$1】の削除が完了しました。'),
    POC_ACCOUNT_UPDATE: 'アプリID変更',
    POC_ACCOUNT_SAVE: '保存',

    POC_ACCOUNT_CHANNEL: 'シークレットCH',
    POC_ACCOUNT_CHANNEL_ADD: 'シークレットCH追加',
    POC_ACCOUNT_CHANNEL_ADD_CONFIRM: 'シークレットCHを追加してもよろしいですか？',
    POC_ACCOUNT_CHANNEL_ADD_SUCCESS: 'シークレットCH追加が完了しました。',
    POC_ACCOUNT_CHANNEL_REMOVE: '複数シークレットCH退出',
    POC_ACCOUNT_CHANNEL_REMOVE_CONFIRM: '複数シークレットCHを退出してもよろしいですか？',
    POC_ACCOUNT_CHANNEL_REMOVE_SUCCESS: '複数シークレットCH退出が完了しました。',
    POC_ACCOUNT_CHANNEL_LIST: 'シークレットCH一覧',


    CALLLOG: '通話履歴',
    CALLLOG_USER_NAME: 'ログインID',
    CALLLOG_DISPLAY_NAME: '表示名',
    CALLLOG_CLIENT_OS_TYPE: 'OSタイプ',
    CALLLOG_CLIENT_APP_VER: 'アプリバージョン',
    CALLLOG_CLIENT_IP_ADDR: 'IPアドレス',
    CALLLOG_CH: 'チャンネル名',
    CALLLOG_LENGTH: '通話時間',
    CHANNELLOG: 'CH利用履歴',

    POC_LOGIN_ID: 'ログインID',
    POC_DISPLAY_NAME: '表示名',
    POC_ACCOUNT_TYPE: '種別',
    POC_ACCOUNT_CH: 'シークレットCH',
    POC_ACCOUNT_OWNER: '管理者',
    POC_ACCOUNT_SIP: 'SIP番号',
    POC_ACCOUNT_STATUS: 'ステータス',
    POC_ACCOUNT_PLAN_TYPE: '種別',
    POC_ACCOUNT_PLAN_TYPE_DISABLE: '無効',
    POC_ACCOUNT_PLAN_TYPE_MONTHLY_PAID: '定額制',
    POC_ACCOUNT_PLAN_TYPE_PREPAID: 'プリペイド',
    POC_ACCOUNT_REMAINING_TIME: '残り時間',
    POC_ACCOUNT_VALID_UNTIL: '有効期限',
    POC_ACCOUNT_ASSIGN: '処理中',
    POC_ACCOUNT_REGISTERED_DATE: '登録日',
    POC_ID: '識別番号',
    POC_UPDATE_STATUS_DATE: '有効化日',

    APP_USER_MANAGEMENT: 'アプリログインID管理',
    APP_USER_MAINTENANCE: 'アプリログインID登録',

    MY_ACCOUNT_DETAILS: 'アプリID及びシークレットCHの詳細',

    // App account settings
    APP_ACCOUNT_MAINTENANCE: 'アプリログインID変更',
    APP_ACCOUNT_PASSWORD_CHANGE: 'アプリログインID変更',
    APP_ACCOUNT_UPDATE: 'アプリログインID変更',
    APP_ACCOUNT_SETTING: 'アプリログインID設定',
    APP_PASSWORD_CHANGE: 'パスワード変更',
    APP_ACCOUNT_ADD: 'アプリログインID登録',

    // APP_LOGIN_ID: 'ログインID',
    APP_LOGIN_ID_EMPTY_ERR: 'ログインIDは未入力です。',
    APP_LOGIN_ID_TOO_SHORT_ERR: 'ログインIDは3文字未満です。ログインIDは3文字以上16文字以下でご入力ください。',
    APP_LOGIN_ID_TOO_LONG_ERR: 'ログインIDは16文字を超えました。ログインIDは3文字以上16文字以下でご入力ください。',

    APP_DISPLAY_NAME: '表示名',
    APP_ID_OWNER: '管理者',
    APP_DISPLAY_NAME_EMPTY_ERR: '表示名は未入力です。',

    APP_ACCOUNT_ROLE: '種別',
    APP_ACCOUNT_TRIAL: 'トライヤル',
    APP_ACCOUNT_PREMIUM: 'プレミアム',

    APP_REGISTRATION_STATUS: 'ステータス',
    APP_REGISTRATION_STATUS_CONFIRM: '登録進行中',
    APP_REGISTRATION_STATUS_NG: 'パッシブ',
    APP_REGISTRATION_STATUS_OK: 'アクティブ',
    APP_ACTIVATION_DATE: '開始日',
    APP_EXPIRATION_DATE: '終了日',
    APP_ACCOUNT_CREATE: '登録',
    APP_ACCOUNT_CREATE_CONFIRM: 'アプリログインIDを登録してもよろしいですか？',
    APP_ACCOUNT_CREATE_SUCCESS: 'アプリログインID登録が完了しました。',
    APP_ACCOUNT_APPROVE_CONFIRM: 'アプリログインIDを承認してもよろしいですか？',
    APP_ACCOUNT_APPROVE_SUCCESS: 'アプリログインID承認が完了しました。',
    APP_ACCOUNT_UPDATE_CONFIRM: 'アプリログインIDを変更してもよろしいですか？',
    APP_ACCOUNT_UPDATE_SUCCESS: 'アプリログインID変更が完了しました。',
    APP_ACCOUNT_SAVE: '保存',

    //  Channel settings
    APP_CHANNEL_MANAGEMENT: 'シークレットチャンネル管理',
    APP_CHANNEL_MAINTENANCE: 'シークレットチャンネル登録',
    APP_CHANNEL_ADD: 'シークレットチャンネル登録',
    APP_CHANNEL_UPDATE: 'シークレットチャンネル変更',

    APP_CHANNEL_NAME: 'チャンネル名',
    APP_CHANNEL_OWNER: '管理者',
    APP_CHANNEL_NAME_EMPTY_ERR: 'チャンネル名は未入力です。',

    APP_CHANNEL_CREATE: '登録',
    APP_CHANNEL_CREATE_CONFIRM: 'シークレットチャンネルを登録してもよろしいですか？',
    APP_CHANNEL_CREATE_SUCCESS: 'シークレットチャンネル登録が完了しました。',
    APP_CHANNEL_APPROVE_CONFIRM: 'シークレットチャンネルを承認してもよろしいですか？',
    APP_CHANNEL_APPROVE_SUCCESS: 'シークレットチャンネル承認が完了しました。',
    APP_CHANNEL_UPDATE_CONFIRM: 'シークレットチャンネルを変更してもよろしいですか？',
    APP_CHANNEL_UPDATE_SUCCESS: 'シークレットチャンネル変更が完了しました。',
    APP_CHANNEL_SAVE: '保存',

    APP_CHANNEL_STATUS: 'ステータス',
    APP_CHANNEL_STATUS_CONFIRM: '登録進行中',
    APP_CHANNEL_STATUS_NG: 'パッシブ',
    APP_CHANNEL_STATUS_OK: 'アクティブ',

    APP_SUMMARY: 'サマリー',
    APP_SUMMARY_PAGE_TITLE: 'サマリーデータ',
    APP_SUMMARY_TITLE: '項目',
    APP_SUMMARY_VALUE: '数量',

    APP_INVOICE: '請求書',
    APP_INVOICE_PAGE_TITLE: '請求書発行',
    APP_INVOICE_CSV_TITLE: 'CSVファイル',
    APP_INVOICE_CSV_IMPORT: '取込',
    APP_INVOICE_CSV_IMPORT_ERROR: '無効なCSVファイルです。',
    APP_INVOICE_TRANSFER_DATE: '実振替日',
    APP_INVOICE_ISSUE: '発行',
    APP_INVOICE_START_CONFIRM: '請求書発行を開始してもよろしいですか？',
    APP_INVOICE_START_SUCCESS: '請求書発行が開始しました。',
    APP_INVOICE_START_ERROR: '無効な顧客番号です。',
    APP_INVOICE_CUSTOMER_ID_ERROR: '無効な顧客番号一覧',

    APP_SUM_TOTAL_USER: '合計ユーザー数',
    APP_SUM_TOTAL_POC_USER: '合計アプリID数',
    APP_SUM_ACTIVE_POC_USER: '有効アプリID数',
    APP_SUM_BAN_POC_USER: '無効アプリID数',
    APP_SUM_TOTAL_POC_CHANNEL: '合計シークレットCH数',
    APP_SUM_ACTIVE_POC_CHANNEL: '有効シークレットCH数',
    APP_SUM_BAN_POC_CHANNEL: '無効シークレットCH数',

    APP_COUPON_LIST: 'クーポンコード管理',
    APP_COUPON_MODEL: '機種',
    APP_COUPON_SERIAL: 'シリアル番号',
    APP_COUPON_ACCOUNT: 'メールアドレス',
    APP_COUPON_APP_ID: 'ログインID',
    APP_COUPON_ACTIVATED_DATE: '使用日',
    APP_COUPON_VALID_UNTIL: '期限日',

    APP_ADMIN_SERVICE_CODE: 'プリペイドコード',
    APP_ADMIN_SERVICE_CODE_TITLE: 'プリペイドコード管理',
    APP_ADMIN_SC_STR: 'コード',
    APP_ADMIN_SC_VOL: '数量',
    APP_ADMIN_SC_USED: '使用済み',
    APP_ADMIN_SC_REMAIN: '残り',
    APP_ADMIN_SC_ADD: 'コード作成',
    APP_ADMIN_SC_ADDED_BY: '作成者',
    APP_ADMIN_SC_ADDED_DATE: '作成日',
    APP_ADMIN_SC_ACTIVATED_BY: '有効化者',
    APP_ADMIN_SC_ACTIVATED_DATE: '有効化日',

    APP_ADMIN_ADD_SC_TITLE: 'プリペイドコード作成',
    APP_ADMIN_ADD_SC_INPUT01: 'プリペイド6桁コード',
    APP_ADMIN_ADD_SC_INPUT02: 'プリペイド4桁コード1',
    APP_ADMIN_ADD_SC_INPUT03: 'プリペイド4桁コード2',
    APP_ADMIN_ADD_SC_INPUT04: 'プリペイド4桁コード3',
    APP_ADMIN_ADD_SC_INPUT05: 'プリペイド4桁コード4',
    APP_ADMIN_ADD_SC_INPUT06: '数量',
    APP_ADMIN_ADD_SC_SUBMIT: '登録',
    // APP_ADMIN_ADD_SC_SUBMIT: '作成',
    APP_ADMIN_ADD_SC_ADD_CONFIRM: 'プリペイドコードを作成してもよろしいですか？',
    APP_ADMIN_ADD_SC_ADD_SUCCESS: 'プリペイドコード作成が完了しました。',

    APP_ADMIN_ADD_SC_INPUT01_EMPTY_ERROR: 'プリペイド6桁コード未入力です。',
    APP_ADMIN_ADD_SC_INPUT02_EMPTY_ERROR: 'プリペイド4桁コード1未入力です。',
    APP_ADMIN_ADD_SC_INPUT03_EMPTY_ERROR: 'プリペイド4桁コード2未入力です。',
    APP_ADMIN_ADD_SC_INPUT04_EMPTY_ERROR: 'プリペイド4桁コード3未入力です。',
    APP_ADMIN_ADD_SC_INPUT05_EMPTY_ERROR: 'プリペイド4桁コード4未入力です。',
    APP_ADMIN_ADD_SC_INPUT06_EMPTY_ERROR: '数量未入力です。',
    APP_ADMIN_ADD_SC_INPUT01_LENGTH_ERROR: '無効なプリペイド6桁コードです。',
    APP_ADMIN_ADD_SC_INPUT02_LENGTH_ERROR: '無効なプリペイド4桁コード1です。',
    APP_ADMIN_ADD_SC_INPUT03_LENGTH_ERROR: '無効なプリペイド4桁コード2です。',
    APP_ADMIN_ADD_SC_INPUT04_LENGTH_ERROR: '無効なプリペイド4桁コード3です。',
    APP_ADMIN_ADD_SC_INPUT05_LENGTH_ERROR: '無効なプリペイド4桁コード4です。',
    APP_ADMIN_ADD_SC_INPUT06_ERROR: '無効な数量です。',

    APP_USER_SERVICE_CODE: 'プリペイドコード',
    APP_USER_SERVICE_CODE_TITLE: 'プリペイドコード管理',
    APP_USER_SC_STR: 'コード',
    APP_USER_SC_VOL: '数量',
    APP_USER_SC_VOL_TOTAL: '合計数量',
    APP_USER_SC_VOL_USED: '使用済み',
    APP_USER_SC_VOL_REMAIN: '残り',
    APP_USER_SC_ACTIVATE: 'コード有効化',
    APP_USER_SC_ADDED_BY: '作成者',
    APP_USER_SC_ADDED_DATE: '作成日',
    APP_USER_SC_ACTIVATED_BY: '有効化者',
    APP_USER_SC_ACTIVATED_DATE: '有効化日',
    APP_USER_ADD_SC_ACTIVATE_CONFIRM: 'プリペイドコードを有効化してもよろしいですか？',
    APP_USER_ADD_SC_ACTIVATE_SUCCESS: 'プリペイドコード有効化設定が完了しました。',

    APP_USER_ADD_SC_TITLE: 'プリペイドコード有効化',
    APP_USER_ADD_SC_INPUT01: 'プリペイド6桁コード',
    APP_USER_ADD_SC_INPUT02: 'プリペイド4桁コード1',
    APP_USER_ADD_SC_INPUT03: 'プリペイド4桁コード2',
    APP_USER_ADD_SC_INPUT04: 'プリペイド4桁コード3',
    APP_USER_ADD_SC_INPUT05: 'プリペイド4桁コード4',
    APP_USER_ADD_SC_INPUT06: '数量',
    APP_USER_ADD_SC_SUBMIT: '作成',

    APP_USER_ADD_SC_INPUT01_EMPTY_ERROR: 'プリペイド6桁コード未入力です。',
    APP_USER_ADD_SC_INPUT02_EMPTY_ERROR: 'プリペイド4桁コード1未入力です。',
    APP_USER_ADD_SC_INPUT03_EMPTY_ERROR: 'プリペイド4桁コード2未入力です。',
    APP_USER_ADD_SC_INPUT04_EMPTY_ERROR: 'プリペイド4桁コード3未入力です。',
    APP_USER_ADD_SC_INPUT05_EMPTY_ERROR: 'プリペイド4桁コード4未入力です。',
    APP_USER_ADD_SC_INPUT06_EMPTY_ERROR: '数量未入力です。',
    APP_USER_ADD_SC_INPUT01_LENGTH_ERROR: '無効なプリペイド6桁コードです。',
    APP_USER_ADD_SC_INPUT02_LENGTH_ERROR: '無効なプリペイド4桁コード1です。',
    APP_USER_ADD_SC_INPUT03_LENGTH_ERROR: '無効なプリペイド4桁コード2です。',
    APP_USER_ADD_SC_INPUT04_LENGTH_ERROR: '無効なプリペイド4桁コード3です。',
    APP_USER_ADD_SC_INPUT05_LENGTH_ERROR: '無効なプリペイド4桁コード4です。',
    APP_USER_ADD_SC_INPUT06_ERROR: '無効な数量です。',

    APP_USER_SC_APPLY_FAILED: 'プリペイドコード有効化にエラーが発生しました。',
    APP_USER_SC_APPLY_ERROR: '無効なプリペイドコードです。',
    APP_USER_SC_REPEAT_ERROR: '５回連続無効なプリペイドコードが入力されたため、暫くの間プリペイドコードを入力いただけません。',
    APP_USER_SC_REAPPLY: '再度プリペイドコードをご入力お願いします。',

    APP_SC_TAB_USAGE_TITLE: 'プリペイドコード使用履歴',
    APP_SC_USAGE_TYPE: '種別',
    APP_SC_USAGE_TYPE_APP_ID: 'アプリID',
    APP_SC_USAGE_TYPE_CHANNEL: 'シークレットCH',
    APP_SC_USAGE_NAME: '表示名',
    APP_SC_USAGE_VOL: '割当数量',
    APP_SC_USAGE_ASSIGNED_AT: '割当日',
    APP_SC_USAGE_PROCESSED_AT: '処理日',
    APP_SC_USAGE_PROCESSED_RESULT: '処理結果',

    APP_PC_MENU: '購入メニュー',
    APP_PC_TAB_PREPAID: 'プリペイドコード',
    APP_PC_TAB_PREPAID_TITLE: 'プリペイドコード購入',
    APP_PC_TAB_MONTHLY: '　　月額利用　　',
    APP_PC_TAB_MONTHLY_TITLE: '月額利用申込',
    APP_PC_TAB_YEARLY: '　　年額利用　　',
    APP_PC_TAB_YEARLY_TITLE: '年額利用申込',
    APP_PC_PREPAID_PAY:'支払う',
    APP_PC_PREPAID_ASSIGN:'ASSIGN',

    APP_PC_UNIT: '単位',
    APP_PC_PRICE: '単価',
    APP_PC_QUANTITY: '数量',
    APP_PC_TOTAL: '小計',
    APP_pc_VOLUME: '使用時間',
    APP_PC_AMOUNT: '合計',
    APP_PC_TAX: '消費税',

    APP_SC_TAB_APPID_TITLE: '　　アプリID割当　　',
    APP_SC_ASSIGN_ID_USERNAME: 'ログインID',
    APP_SC_ASSIGN_ID_DISPLAY_NAME: '表示名',
    APP_SC_ASSIGN_ID_POC_ID: '識別番号',
    APP_SC_ASSIGN_ID_TYPE: 'アカウント種別',
    APP_SC_ASSIGN_ID_TYPE_DISABLE: '無効',
    APP_SC_ASSIGN_ID_TYPE_PREPAID: 'プリペイド',
    APP_SC_ASSIGN_ID_TYPE_MONTHLY_PAID: '定額制',
    APP_SC_ASSIGN_ID_REMAIN_TIME: '残り時間',
    APP_SC_ASSIGN_ID_VALID_UNTIL: '有効期限',
    APP_SC_ASSIGN_ID_VOL: '割当数量',
    APP_SC_ASSIGN_ID_REMAIN_TIME_AFTER: '割当後',
    APP_SC_ASSIGN_ID_ASSIGNING: '処理中',
    APP_SC_ASSIGN_ID: '割当実行',
    APP_SC_ASSIGN_ID_CONFIRM: '割当を実行してもよろしいですか？割当を実行した後、取消や変更はできません。',
    APP_SC_ASSIGN_ID_SUCCESS: 'プリペイドコード割当を受付しました。残り時間を更新するまで少しの時間が必要となりますのでご了承ください。',
    APP_SC_DELETE_CONFIRM: 'プリペイドコードを消去してもよろしいですか？',
    APP_SC_DELETE_SUCCESS: 'プリペイドコード消去が完了しました。',

    APP_SC_TAB_CHANNEL_TITLE: 'シークレットCH割当',
    APP_SC_ASSIGN_CHANNEL_USERNAME: 'ログインID',
    APP_SC_ASSIGN_CHANNEL_DISPLAY_NAME: '表示名',
    APP_SC_ASSIGN_CHANNEL_GROUP_ID: '識別番号',
    APP_SC_ASSIGN_CHANNEL_TYPE: 'アカウント種別',
    APP_SC_ASSIGN_CHANNEL_TYPE_DISABLE: '無効',
    APP_SC_ASSIGN_CHANNEL_TYPE_PREPAID: 'プリペイド',
    APP_SC_ASSIGN_CHANNEL_TYPE_MONTHLY_PAID: '定額制',
    APP_SC_ASSIGN_CHANNEL_REMAIN_TIME: '残り時間',
    APP_SC_ASSIGN_CHANNEL_ASSIGNING: '処理中',
    APP_SC_ASSIGN_CHANNEL_VALID_UNTIL: '有効期限',
    APP_SC_ASSIGN_CHANNEL_VOL: '割当数量',
    APP_SC_ASSIGN_CHANNEL_REMAIN_TIME_AFTER: '割当後',
    APP_SC_ASSIGN_CHANNEL: '割当実行',
    APP_SC_ASSIGN_CHANNEL_CONFIRM: '割当を実行してもよろしいですか？割当を実行した後、取消や変更はできません。',
    APP_SC_ASSIGN_CHANNEL_SUCCESS: 'プリペイドコード割当を受付しました。残り時間を更新するまで少しの時間が必要となりますのでご了承ください。',
    // APP_SC_ASSIGN_CHANNEL_SUCCESS: 'プリペイドコード割当が完了しました。',

		APP_SC_ASSIGN_VOLUME_OVER: '割当値が無効です。（残り時間が最大8000時間です。）',

    APP_PC_TAB_CHANNEL_TITLE: 'シークレットCH割当',
    APP_PC_TAB_APPID_TITLE: '　　アプリID割当　　',

    APP_LINKS: '各種リンク',
    APP_FINCODE_USER: 'ユーザーの一覧',

    FINCODE_TITLE: '購入履歴',
    FINCODE_ORDER_ID: 'オーダー番号',
    FINCODE_EMAIL: 'メール',
    FINCODE_VOLUME: '使用時間',
    FINCODE_AMOUNT: '合計',
    FINCODE_STATUS: 'ステータス',
    FINCODE_CREATED_AT: '作成日',
    FINCODE_EXPIRE: '期限',





    MAIL_ADDRESS_HINT: 'ヒント',
    LOCATION_IS_NOT_FORMAT:
      '受け付けできない値になっています。ロケーションを「度（Degree Decimal）」というフォーマットで入力してください。',
    CURRENT_LOCATION: '現在位置',
    GET_CURRENT_LOCATION_CONFIRM:
      'Webアプリへログイン中のパソコン・スマホの位置情報をロケーション設定に使用しますか？（使用する場合、アプリが位置情報にアクセスできるように、パソコン・スマホの位置情報アクセス設定をONにしてください。）',
    CURRENT_LOCATION_DISABLE: 'ﾊﾟｿｺﾝ･ｽﾏﾎの位置情報ｱｸｾｽ設定がｵﾌになっています',
    SHOW_PICTURE: 'レイアウト図表示へ',
    HIDE_PICTURE: '　　地図表示へ　　',
    UPLOAD_IMAGE: 'レイアウト図アップロード',
    UPLOAD_IMAGE_SUCCESS: 'レイアウト図アップロードが完了しました。',
    UPLOAD_IMAGE_CONFIRM: 'レイアウト図をアップロードしてもよろしいですか？',
    DELETE_DATA: '装置のデータを消去します。',
    DELETE_DATA_CONFIRM: '装置のデータを消去してもよろしいですか？',
    MAIL_DETAIL: 'メール詳細',
    PHONE_DETAIL: 'アラート詳細',
    ADD_GPS_SETTING: 'ジオフェンス登録',
    UPDATE_GPS_SETTING: 'ジオフェンス更新',
    GEO_RADIUS: '半径(m)',
    GEO_REGION_NAME: '地名',
    GEO_CHECK_IN: '進入通知',
    GEO_CHECK_OUT: '退出通知',
    GEO_HOLD_TIME: '長期滞在判定閾値(分)',
    GEO_HOLD_TIME_REPEAT: '繰り返し送信間隔(分)',
    GEO_LIST_TITLE: 'ジオフェンス一覧',
    GEO_EDIT: '編集',
    GEO_DELETE: 'ジオフェンス($1)を消去してもよろしいですか？',
    GEO_DELETED: 'ジオフェンス($1)を消去しました。',
    GEO_NAME_EMPTY_ERR: '地名は未入力です。',

    DKSF03WT2_FLOOD_OK: '水位情報 渇水状態',
    DKSF03WT2_FLOOD_NG: '水位情報 浸水状態',

    DKSF03WT2_FLOOD_AB_OK: '水位情報A、水位情報Bともに渇水状態',
    DKSF03WT2_FLOOD_A_NG: '水位情報A 浸水状態、水位情報B 渇水状態',
    DKSF03WT2_FLOOD_B_NG: '水位情報A 渇水状態、水位情報B 浸水状態',
    DKSF03WT2_FLOOD_AB_NG: '水位情報A、水位情報Bともに浸水状態',

    DKSF03WT2_TILT_OK: '傾斜無し',
    DKSF03WT2_TILT_NG: '傾斜異常',

    DKSF03WT2_BATTERY_OK: '電池正常',
    DKSF03WT2_BATTERY_NG: '減電池',

    DKSF03WT2_TIMEOUT: '定時連絡未送信',
    DKSF03WT2_MAIL_SETTING: 'メール送信設定',

    DKSF07_TILT_OK: '傾斜無し',
    DKSF07_TILT_NG: '傾斜異常',
    DKSF07_MAIL_SETTING: 'メール送信設定',
    //Call logs

  },
};

export default string;
